module.exports = __webpack_public_path__ + "img/ecolesecpierrelaporte.1ad45d74.jpg";